import React, { useEffect, useState } from 'react';
import FramePlayer from '../utils/FramePlayer';
import ImageButton from '../utils/ImageButton';
import '../css/button.css';
import '../css/menu_dida.css';
import anime from 'animejs';
import { Navigate } from 'react-router-dom';
import lang from '../lang.json';

const MenuDida = (props) => {

    const langue = props.langue;
    const setLangue = props.setLangue;
    const texts = lang.lang[`lang_${langue}`].menu_dida;

    const [red1, setRed1] = useState(false);
    const [red2, setRed2] = useState(false);
    const [red3a, setRed3a] = useState(false);
    const [red3b, setRed3b] = useState(false);
    const [red3c, setRed3c] = useState(false);
    const [red3d, setRed3d] = useState(false);
    const [red3e, setRed3e] = useState(false);
    const [red3f, setRed3f] = useState(false);
    const [red4a, setRed4a] = useState(false);
    const [red4b, setRed4b] = useState(false);
    const [red4c, setRed4c] = useState(false);
    const [red5a, setRed5a] = useState(false);
    const [red5b, setRed5b] = useState(false);
    const [red5c, setRed5c] = useState(false);
    const [red5d, setRed5d] = useState(false);
    const [red5e, setRed5e] = useState(false);
    const [red5f, setRed5f] = useState(false);
    const [red6a, setRed6a] = useState(false);
    const [red6b, setRed6b] = useState(false);
    const [red6c, setRed6c] = useState(false);

    useEffect(() => {
        var tl = anime.timeline({
            //complete: callback
        })
        tl
            .add({
                targets: '.button',
                opacity: 1,
                duration: 600,
                easing: 'easeInSine',
            }, 4200)
    }, []);


    useEffect(() => {
        if (red1) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/intro';
        }
    }, [red1]);
    useEffect(() => {
    if (red2) {
        window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/captation/';
    }
    }, [red2]);

    useEffect(() => {
        if (red3a) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/imitation/';
        }
    }, [red3a]);

    useEffect(() => {
        if (red3b) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/imitation/2-markov/';
        }
    }, [red3b]);

    useEffect(() => {
        if (red3c) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/imitation/3-donnalee/';
        }
    }, [red3c]);

    useEffect(() => {
        if (red3d) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/imitation/4-uzeste/';
        }
    }, [red3d]);

    useEffect(() => {
        if (red3e) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/imitation/5-walking/';
        }
    }, [red3e]);

    useEffect(() => {
        if (red3f) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/imitation/6-motives/';
        }
    }, [red3f]);

    useEffect(() => {
        if (red4a) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/transfo-a/';
        }
    }, [red4a]);

    useEffect(() => {
        if (red4b) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/transfo-a/2-patch/';
        }
    }, [red4b]);

    useEffect(() => {
        if (red4c) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/transfo-a/3-arpeggios/';
        }
    }, [red4c]);

    useEffect(() => {
        if (red5a) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/transfo-b/';
        }
    }, [red5a]);

    useEffect(() => {
        if (red5b) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/transfo-b/2-hothouse/';
        }
    }, [red5b]);

    useEffect(() => {
        if (red5c) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/transfo-b/3-rewrite/';
        }
    }, [red5c]);

    useEffect(() => {
        if (red5d) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/transfo-b/4-godel/';
        }
    }, [red5d]);

    useEffect(() => {
        if (red5e) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/transfo-b/5-subtitute/';
        }
    }, [red5e]);

    useEffect(() => {
        if (red5f) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/transfo-b/6-goodbye/';
        }
    }, [red5f]);

    useEffect(() => {
        if (red6a) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/control/';
        }
    }, [red6a]);

    useEffect(() => {
        if (red6b) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/control/2-lubatyscaphe/';
        }
    }, [red6b]);

    useEffect(() => {
        if (red6c) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/control/3-memory/';
        }
    }, [red6c]);


    return (<>

        <FramePlayer dirName="menu_dida"
            frameNumber={50}
            fps={10}
            initialDelay={200}
        />

        <ImageButton classNameForButton="button inflateButtonLotMore"
            dirName="menu_dida"
            id="1"
            x={164}
            y={59}
            callback={
                () => { setRed1(true); }}
            style={
                { zIndex: 2, cursor: "pointer" }}
        />

        <ImageButton classNameForButton="button inflateButtonMore"
            dirName="menu_dida"
            id="2"
            x={-2}
            y={130}
            callback={
                () => { setRed2(true); }}
            style={
                { zIndex: 2, cursor: "pointer" }}
        />

        <ImageButton classNameForButton="button inflateButtonLotMore"
            dirName="menu_dida"
            id="3"
            x={103}
            y={218}
            callback={
                () => { setRed3a(true); }}
            style={
                { zIndex: 2, cursor: "pointer", scale: '1.05' }}
        />

        <ImageButton classNameForButton="button inflateButtonMore"
            dirName="menu_dida"
            id="4"
            x={335}
            y={203}
            callback={
                () => { setRed4a(true); }}
            style={
                { zIndex: 2, cursor: "pointer" }}
        />

        <ImageButton classNameForButton="button inflateButtonMore"
            dirName="menu_dida"
            id="5"
            x={280}
            y={312}
            callback={
                () => { setRed5a(true); }}
            style={
                { zIndex: 2, cursor: "pointer", scale: '1.05' }}
        />

        <ImageButton classNameForButton="button inflateButtonLittle"
            dirName="menu_dida"
            id="6"
            x={489}
            y={328}
            callback={
                () => { setRed6a(true); }}
            style={
                { zIndex: 2, cursor: "pointer", scale: '0.8' }}
        />

        <ImageButton classNameForButton="button inflateButtonLittle"
            dirName="menu_dida"
            id="button"
            x={78}
            y={308}
            callback={
                () => { setRed3b(true); }}
            style={
                { zIndex: 2, cursor: "pointer", scale: '0.7' }}
        />

        <ImageButton classNameForButton="button inflateButtonLittle"
            dirName="menu_dida"
            id="button"
            x={61}
            y={325}
            callback={
                () => { setRed3c(true); }}
            style={
                { zIndex: 2, cursor: "pointer", scale: '0.7' }}
        />

        <ImageButton classNameForButton="button inflateButtonLittle"
            dirName="menu_dida"
            id="button"
            x={52}
            y={345}
            callback={
                () => { setRed3d(true); }}
            style={
                { zIndex: 2, cursor: "pointer", scale: '0.7' }}
        />

        <ImageButton classNameForButton="button inflateButtonLittle"
            dirName="menu_dida"
            id="button"
            x={58}
            y={366}
            callback={
                () => { setRed3e(true); }}
            style={
                { zIndex: 2, cursor: "pointer", scale: '0.7', rotate: '30deg' }}
        />

        <ImageButton classNameForButton="button inflateButtonLittle"
            dirName="menu_dida"
            id="button"
            x={84}
            y={375}
            callback={
                () => { setRed3f(true); }}
            style={
                { zIndex: 2, cursor: "pointer", scale: '0.7' }}
        />

        <ImageButton classNameForButton="button inflateButtonLittle"
            dirName="menu_dida"
            id="button"
            x={440}
            y={242}
            callback={
                () => { setRed4b(true); }}
            style={
                { zIndex: 2, cursor: "pointer", scale: '0.7' }}
        />

        <ImageButton classNameForButton="button inflateButtonLittle"
            dirName="menu_dida"
            id="button"
            x={468}
            y={233}
            callback={
                () => { setRed4c(true); }}
            style={
                { zIndex: 2, cursor: "pointer", scale: '0.7' }}
        />

        <ImageButton classNameForButton="button inflateButtonLittle"
            dirName="menu_dida"
            id="button"
            x={255}
            y={435}
            callback={
                () => { setRed5b(true); }}
            style={
                { zIndex: 2, cursor: "pointer", scale: '0.7' }}
        />

        <ImageButton classNameForButton="button inflateButtonLittle"
            dirName="menu_dida"
            id="button"
            x={210}
            y={431}
            callback={
                () => { setRed5c(true); }}
            style={
                { zIndex: 2, cursor: "pointer", scale: '0.7' }}
        />

        <ImageButton classNameForButton="button inflateButtonLittle"
            dirName="menu_dida"
            id="button"
            x={175}
            y={450}
            callback={
                () => { setRed5d(true) }}
            style={
                { zIndex: 2, cursor: "pointer", scale: '0.7' }}
        />

        <ImageButton classNameForButton="button inflateButtonLittle"
            dirName="menu_dida"
            id="button"
            x={187}
            y={472}
            callback={
                () => { setRed5e(true) }}
            style={
                { zIndex: 2, cursor: "pointer", scale: '0.7' }}
        />

        <ImageButton classNameForButton="button inflateButtonLittle"
            dirName="menu_dida"
            id="button"
            x={218}
            y={474}
            callback={
                () => { setRed5f(true) }}
            style={
                { zIndex: 2, cursor: "pointer", scale: '0.7' }}
        />

        <ImageButton classNameForButton="button inflateButtonLittle"
            dirName="menu_dida"
            id="button"
            x={589}
            y={408}
            callback={
                () => { setRed6b(true); }}
            style={
                { zIndex: 2, cursor: "pointer", scale: '0.7' }}
        />

        <ImageButton classNameForButton="button inflateButtonLittle"
            dirName="menu_dida"
            id="button"
            x={625}
            y={410}
            callback={
                () => { setRed6c(true); }}
            style={
                { zIndex: 2, cursor: "pointer", scale: '0.7' }}
        />

        {/* titre menu dida en jaune en haut à gauche */}
        <p
            className='button'
            style={{
                position: 'absolute',
                left: 10,
                top: 0,
                color: 'yellow',
                fontSize: '15px', 
            }}
        >{texts.lang1}</p>

        {/* label bouton */}
        <p
            className='button'
            style={{
                position: 'absolute',
                left: 210,
                top: 111,
                color: '#f74888',
                zIndex: 3,
            }}
        >{texts.lang2}</p>
        <p
            className='button'
            style={{
                position: 'absolute',
                left: 77,
                top: 168,
                color: '#f74888',
                zIndex: 3,
            }}
        >{texts.lang3}</p>
        <p
            className='button'
            style={{
                position: 'absolute',
                left: 147,
                top: 270,
                color: '#f74888',
                zIndex: 3,
            }}
        >{texts.lang4}</p>
        <p
            className='button'
            style={{
                position: 'absolute',
                left: 377,
                top: 261,
                color: '#f74888',
                zIndex: 3,
            }}
        >{texts.lang5}</p>
        <p
            className='button'
            style={{
                position: 'absolute',
                left: 327,
                top: 415,
                color: '#f74888',
                zIndex: 3,
            }}
        >{texts.lang6}</p>
        <p
            className='button'
            style={{
                position: 'absolute',
                left: 527,
                top: 431,
                color: '#f74888',
                zIndex: 3,
            }}
        >{texts.lang7}</p>

        
    </>

    );
}

export default MenuDida;


/*
{red2 && <Navigate to={process.env.PUBLIC_URL + "/module/2-captation/"} />}
        {red3a && <Navigate to={process.env.PUBLIC_URL + "/module/3-imitation-1/"} />}
        {red3b && <Navigate to={process.env.PUBLIC_URL + "/module/3-imitation-2-markov/"} />}
        {red3c && <Navigate to={process.env.PUBLIC_URL + "/module/3-imitation-3-donnalee/"} />}
        {red3d && <Navigate to={process.env.PUBLIC_URL + "/module/3-imitation-4-uzeste/"} />}
        {red3e && <Navigate to={process.env.PUBLIC_URL + "/module/3-imitation-5-walking/"} />}
        {red3f && <Navigate to={process.env.PUBLIC_URL + "/module/3-imitation-6/"} />}
        {red4a && <Navigate to={process.env.PUBLIC_URL + "/module/transfo-a/1/"} />}
        {red4b && <Navigate to={process.env.PUBLIC_URL + "/module/transfo-a/2-patch/"} />}
        {red4c && <Navigate to={process.env.PUBLIC_URL + "/module/transfo-a/3-arpeges/"} />}
        {red5a && <Navigate to={process.env.PUBLIC_URL + "/module/transfo-b/1/"} />}
        {red5b && <Navigate to={process.env.PUBLIC_URL + "/module/transfo-b/2-hothouse/"} />}
        {red5c && <Navigate to={process.env.PUBLIC_URL + "/module/transfo-b/3-godel/"} />}
        {red5d && <Navigate to={process.env.PUBLIC_URL + "/module/transfo-b/4-reecritures/"} />}
        {red5e && <Navigate to={process.env.PUBLIC_URL + "/module/transfo-b/5-subtitutions/"} />}
        {red5f && <Navigate to={process.env.PUBLIC_URL + "/module/transfo-b/5-goodbye/"} />}
        {red6a && <Navigate to={process.env.PUBLIC_URL + "/module/6-control-1/"} />}
        {red6b && <Navigate to={process.env.PUBLIC_URL + "/module/6-control-2-lubatyscaphe/"} />}
        {red6c && <Navigate to={process.env.PUBLIC_URL + "/module/6-control-3-memoire/"} />}
*/